import React, { useEffect, useRef, useState } from "react";
import FormUI from '@/componentsUI/Form';
import { feedback } from "@/utils/feedback";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import {
  useWalletAll,
  useWalletWithdrawFlat,
  useWithdrawFlat,
} from "@/store/walletStore";
import { useUserInfo } from "@/store/userInfo";
import FromItemPlus from "@/components/FormItemPlus/FromItemPlus";
import WidthdrawCurrency from "../compoments/widthdrawCurrency/WidthdrawCurrency";
import LoadingUI from "@/componentsUI/LoadingUI/LoadingUI";
import { IFInitWalletWithdrawFlatReq } from "@/api/apiReq/IFWalletReq";
import { sys } from "@/Core/utils/system";
import WidthdrawPix from "../pix/WidthdrawPix";
import {
  IFInitWalletRsp,
  IFInitWalletWithdrawFlatRsp,
} from "@/api/apiRsp/IFWalletRsp";
import ButtonUI from "@/componentsUI/Button";
import "../index.less";
import useDialogManager from "@/utils/useDialogManager";
import {
  AmountMultiplierConversion,
  dealAmount9Valid,
} from "@/Core/utils/currencyDealCenter";
import useDialog from "@/utils/useDialog";
import { useCurrency } from "@/hooks/useCurrency";
import InternalWithdrawWayField from "../compoments/widthdrawWay/InternalWithdrawWayField";
import WidthdrawedPix from "../pix/WidthdrawedPix";
import PaymentMethodSelector from "../../../shared/PaymentMethodSelector";
import MobileInput from "../compoments/mobileInput/MobileInput";
import { getWithdrawalMobile } from "@/utils/mobileUtils";
import {
  getCurrentCountryCode,
} from "@/utils/countryConfigUtils";
import SenegalWithdrawConfirmModal from "../compoments/SenegalWithdrawConfirmModal/SenegalWithdrawConfirmModal";
import { getWalletWithdrawMethodOptions } from "@/pages/wallet/strategy/walletStrategy";
import WithdrawConfirmModal from "../compoments/WithdrawConfirmModal/WithdrawConfirmModal";
import {
  getWithdrawConfirmEmailRequired,
  getWithdrawConfirmEmailTarget,
  getWithdrawConfirmMode,
} from "./withdrawConfirmRules";
import { runWithdrawalOfficialAppPrompt } from "@/features/install/withdrawalOfficialAppPrompt";

const FlatWithdrawDefault = () => {
  const [form] = FormUI.useForm();
  const { t } = useTranslationPlus();
  const currency = useCurrency();
  const { data: wallets } = useWalletAll();
  const { data: userInfo } = useUserInfo();
  const formValidateRef = useRef(null);
  const [params, setParams] = useState<IFInitWalletWithdrawFlatReq>(
    wallets?.flat
      ? {
          currencyType:
            wallets?.flat[0]?.serverCurrencyType ||
            wallets?.flat[0]?.currencyType,
          device: sys.device,
        }
      : null
  );
  const { data, isValidating, error, mutate } = useWithdrawFlat(params);
  const [currentWallet, setCurrentWallet] = useState<IFInitWalletRsp>(
    wallets?.flat?.[0]
  );

  const [widthdrawConfig, setWidthdrawConfig] =
    useState<IFInitWalletWithdrawFlatRsp>();

  const [bankType, setBankType] = useState("");
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [pendingWithdrawData, setPendingWithdrawData] = useState(null);
  const isBeninUser =
    (getCurrentCountryCode() || "").toLowerCase() === "bj";
  const currentCountryCode = getCurrentCountryCode();
  const confirmMode = getWithdrawConfirmMode(currentCountryCode);
  const confirmEmailRequired =
    getWithdrawConfirmEmailRequired(currentCountryCode);
  const confirmEmailTarget =
    getWithdrawConfirmEmailTarget(currentCountryCode);

  useEffect(() => {
    if (data?.configParams?.[0]?.options?.accountType) {
      const filteredTypes = getWalletWithdrawMethodOptions();
      const fallbackTypes =
        data.configParams[0].options.accountType.split(",") || [];
      const methodOptions = filteredTypes.length
        ? filteredTypes
        : fallbackTypes;
      const defaultMethod = methodOptions[0];

      if (defaultMethod) {
        setBankType(defaultMethod.trim());
      }
    }
  }, [data]);

  useEffect(() => {
    if (!isBeninUser || !data?.configParams?.length || !bankType) {
      return;
    }

    const targetType = bankType.trim().toLowerCase() === "moov" ? 104 : 102;
    const targetConfig = data.configParams.find(
      (config) => config.withdrawType === targetType
    );

    if (
      targetConfig &&
      targetConfig.withdrawType !== widthdrawConfig?.withdrawType
    ) {
      form.setFieldValue("witdrawWay", {
        type: targetConfig.withdrawType,
        data: targetConfig,
      });
      setWidthdrawConfig(targetConfig);
    }
  }, [bankType, data, form, isBeninUser, widthdrawConfig]);

  function changeWidthdraw(index) {
    const item = wallets.flat?.[index];
    if (!item) {
      return;
    }
    setParams({
      currencyType: item.serverCurrencyType || item.currencyType,
      device: sys.device,
    });
    setCurrentWallet(item);
  }

  useEffect(() => {
    if (wallets?.flat?.length) {
      form.setFieldValue("walletType", wallets?.flat?.[0]?.currencyType);
    }
  }, [wallets]);

  useEffect(() => {
    form.setFieldValue(
      "mobile",
      getWithdrawalMobile(userInfo?.mobile, userInfo?.userId)
    );
  }, [userInfo]);

  const { trigger } = useWalletWithdrawFlat();
  const { openGoogleTowFactor } = useDialogManager();
  const { closeAll } = useDialog();

  const pixWidthdraw = (v) => {
    const cpf = v?.cpf?.replaceAll(".", "").replaceAll("-", "");
    const accountInfo: any = {
      pixFullName: v.accountName,
      pixCpf: cpf,
      pixType: bankType,
      pixAccount: cpf,
    };

    if (v.confirmUserInfo?.fullName) {
      accountInfo.pixFullName = v.confirmUserInfo.fullName;
      if (v.confirmUserInfo.email && v.confirmUserInfo.email.trim() !== "") {
        accountInfo[confirmEmailTarget] = v.confirmUserInfo.email;
      }
    }

    if (v.senegalUserInfo) {
      accountInfo.pixFullName = v.senegalUserInfo.firstName;
      accountInfo.pixCpf = v.senegalUserInfo.lastName;
      if (v.senegalUserInfo.email && v.senegalUserInfo.email.trim() !== "") {
        accountInfo.email = v.senegalUserInfo.email;
      }
    }

    const selectedWallet = wallets?.flat?.find(
      (wallet) => wallet.currencyType === v.walletType
    );

    const mappedWithdrawType = isBeninUser
      ? bankType.trim().toLowerCase() === "moov"
        ? 104
        : 102
      : v.witdrawWay.type;

    const requestParams = {
      currencyType:
        selectedWallet?.serverCurrencyType || v.walletType,
      money: AmountMultiplierConversion(Math.floor(v.amount), {
        currencyType: selectedWallet?.currencyType,
        serverCurrencyType: selectedWallet?.serverCurrencyType,
      }),
      withdrawType: mappedWithdrawType,
      accountInfo: JSON.stringify(accountInfo),
      accountType: bankType,
      mobile: v.mobile,
      withdrawMobileUserId: userInfo?.userId,
    };
    trigger(requestParams)
      .then((res) => {
        if (res?.googleAuth) {
          openGoogleTowFactor({
            trigger: trigger,
            params: requestParams,
            complete: () => {
              closeAll();
            },
          });
        } else {
          closeAll();
        }
      })
      .catch((e) => {
        if (e?.code == "ERROR_60028") {
          if (e?.data?.withdrawAmount == 0) {
            feedback.error(
              t("WITHDRAW_NEED_BET", {
                betCode: dealAmount9Valid(e?.data?.betTarget, {
                  currencyType: e?.data?.currency,
                }),
                currency,
              })
            );
          } else {
            feedback.error(
              t("WITHDRAW_ALREADY_BET", {
                alreadyCode: dealAmount9Valid(e?.data?.withdrawAmount, {
                  currencyType: e?.data?.currency,
                }),
                currency,
              })
            );
          }
        } else {
          feedback.error(t(e?.code));
        }
      });
  };

  const onClickWidthdraw = () => {
    formValidateRef.current = true;
    form
      .validate()
      .then((v) =>
        runWithdrawalOfficialAppPrompt({
          stage: "before_submit",
          userId: userInfo?.userId,
          onContinue: () => {
            if (confirmMode !== "none") {
              setPendingWithdrawData(v);
              setShowConfirmModal(true);
            } else {
              pixWidthdraw(v);
            }
          },
        }),
      )
      .finally(() => {
        formValidateRef.current = false;
      });
  };

  function changeType({ data }) {
    setWidthdrawConfig(data);
  }

  const handleWithdrawConfirm = (confirmData: {
    fullName: string;
    email?: string;
  }) => {
    if (pendingWithdrawData) {
      const enhancedData = {
        ...pendingWithdrawData,
        confirmUserInfo: confirmData,
      };
      pixWidthdraw(enhancedData);
    }
    setShowConfirmModal(false);
    setPendingWithdrawData(null);
  };

  const handleSenegalConfirm = (confirmData: {
    firstName: string;
    lastName: string;
    email: string;
  }) => {
    if (pendingWithdrawData) {
      const enhancedData = {
        ...pendingWithdrawData,
        senegalUserInfo: confirmData,
      };
      pixWidthdraw(enhancedData);
    }
    setShowConfirmModal(false);
    setPendingWithdrawData(null);
  };

  const handleConfirmClose = () => {
    setShowConfirmModal(false);
    setPendingWithdrawData(null);
  };

  useEffect(() => {
    if (data && data?.configParams && !widthdrawConfig) {
      form.setFieldValue("witdrawWay", {
        type: data.configParams[0].withdrawType,
        data: data.configParams[0],
      });
      setWidthdrawConfig(data.configParams[0]);
    }
  }, [data, widthdrawConfig]);

  return (
    <div className="flat-widthdraw">
      <FormUI form={form} layout={"vertical"} autoComplete={"off"}>
        <FromItemPlus
          field={"walletType"}
          label={t("Wallet.WithdrawCurrencyTitle")}
        >
          <WidthdrawCurrency
            currencys={wallets?.flat}
            onChange={(_value: any, option: any) => {
              changeWidthdraw(option?._index);
            }}
          />
        </FromItemPlus>

        <LoadingUI
          isLoading={isValidating}
          error={error}
          dataList={data}
          retryFunc={mutate}
          className="wallet-flat-loading-state"
        >
          <>
            <InternalWithdrawWayField
              configs={data?.configParams}
              onChange={changeType}
            />

            {(widthdrawConfig?.withdrawType === 102 || isBeninUser) && (
              <div className="withdraw-method-section">
                <label className="method-label">{t("Wallet.Method")}</label>
                <PaymentMethodSelector
                  methods={
                    getWalletWithdrawMethodOptions().length
                      ? getWalletWithdrawMethodOptions()
                      : data?.configParams?.[0]?.options?.accountType?.split(
                          ","
                        ) || []
                  }
                  selectedMethod={bankType}
                  onMethodSelect={setBankType}
                  className="withdraw-bank-selector"
                />
              </div>
            )}

            {(widthdrawConfig?.withdrawType === 102 || isBeninUser) && (
              <div className="withdraw-mobile-section">
                <FromItemPlus
                  field={"mobile"}
                  label={t("Wallet.Mobile Number")}
                  className="withdraw-mobile-item"
                  rules={[
                    {
                      required: true,
                      message: t("Wallet.Please enter mobile number"),
                    },
                    {
                      validator: (value, cb) => {
                        if (value && (value.length < 8 || value.length > 10)) {
                          return cb(t("Wallet.Mobile number must be"));
                        }
                        return cb();
                      },
                    },
                  ]}
                >
                  <MobileInput />
                </FromItemPlus>
                <div className="important-notice">
                  {t("Wallet.WithdrawPhoneNotice")}
                </div>
              </div>
            )}

            {widthdrawConfig?.withdrawType === 102 && (
              <WidthdrawPix
                data={data}
                widthdrawConfig={widthdrawConfig}
                currentWallet={currentWallet}
                form={form}
                formValidateRef={formValidateRef}
              />
            )}
            {widthdrawConfig?.withdrawType === 104 &&
              !data?.userAccount?.pixCpf && (
                <WidthdrawPix
                  data={data}
                  widthdrawConfig={widthdrawConfig}
                  currentWallet={currentWallet}
                  form={form}
                  formValidateRef={formValidateRef}
                />
              )}
            {widthdrawConfig?.withdrawType === 104 &&
              data?.userAccount?.pixCpf && (
                <WidthdrawedPix
                  data={data}
                  widthdrawConfig={widthdrawConfig}
                  currentWallet={currentWallet}
                  form={form}
                  formValidateRef={formValidateRef}
                />
              )}
          </>
        </LoadingUI>
      </FormUI>

      <ButtonUI
        className={`widthdraw-btn`}
        type="primary"
        onClick={onClickWidthdraw}
      >
        {t("Wallet.Withdraw")}
      </ButtonUI>

      {showConfirmModal && confirmMode === "fullNameEmail" && (
        <WithdrawConfirmModal
          visible={showConfirmModal}
          onClose={handleConfirmClose}
          onConfirm={handleWithdrawConfirm}
          withdrawData={pendingWithdrawData}
          requireEmail={confirmEmailRequired}
        />
      )}

      {showConfirmModal && confirmMode === "firstLastEmail" && (
        <SenegalWithdrawConfirmModal
          visible={showConfirmModal}
          onClose={handleConfirmClose}
          onConfirm={handleSenegalConfirm}
          withdrawData={pendingWithdrawData}
        />
      )}
    </div>
  );
};

export default FlatWithdrawDefault;
